// extracted by mini-css-extract-plugin
export default {"pill":"sfxge AgyN9 rdWnq Z_N7p mTYn5 g_uoF zHivW fgFgv","pillWithoutIcon":"sNPT5","pillIconBefore":"iWrk1","icon":"ZpkSr"};